import { useCallback, useState } from 'react';
import { CrmOrg } from '../../../../types/CrmOrgs';
import { telemetry } from '../../../../telemetry';
import { SweepNotificationVariant } from '../../../../reducers/notificationsReducer';
import { useSweepNotifications } from '../../../notifications/useSweepNotifications';
import { EditableLabel } from '../../../common/EditableLabel';
import { __SWEEP_DESIGN_TYPOGRAPHY_STYLES___, colors } from '@sweep-io/sweep-design';
import { EditableLabelRef } from '../../../common/EditableLabel';
import { useCrmOrgs } from '../useCrmOrgs';
import { useFeatureToggle } from '../../../../feature-flags/useFeatureToggle';

const newInputStyles = {
  height: '32px',
  lineHeight: '32px',
  borderRadius: '4px',

  '&:hover, &:focus': {
    backgroundColor: colors.white,
    borderColor: colors.grey[300],
  },

  '&:focus': {
    borderColor: colors.blue[500],
  },
};

export const EnvironmentName = ({
  env,
  editableLabelRef,
}: {
  env: CrmOrg;
  editableLabelRef: React.RefObject<EditableLabelRef> | ((ref: EditableLabelRef | null) => void);
}) => {
  const { environmentsPage } = useFeatureToggle();
  const { addNotification } = useSweepNotifications();
  const { renameCrmOrg } = useCrmOrgs();
  const [envName, setEnvName] = useState(env.name);

  const confirmRenameHandler = useCallback(
    async (name: string) => {
      setEnvName(name);
      try {
        await renameCrmOrg(env.id, name.trim());
      } catch (e) {
        telemetry.captureError(e);
        addNotification({
          message: 'Unknown error',
          variant: SweepNotificationVariant.Error,
          keepOpen: true,
        });
        setEnvName(env.name);
      }
    },
    [addNotification, env.id, env.name, renameCrmOrg],
  );

  return (
    <EditableLabel
      value={envName}
      onValueConfirm={confirmRenameHandler}
      padding={environmentsPage ? '0px 8px 0px 4px' : '0px 8px 0px 0px'}
      inputSx={{
        ...__SWEEP_DESIGN_TYPOGRAPHY_STYLES___['body-medium'],
        ...(environmentsPage ? newInputStyles : {}),
      }}
      ref={editableLabelRef}
    />
  );
};
